export class AdvancedDailyEngagedUserMonthlyUsage {
  botName!: string;
  botId!: string;

  dailyEngagedUserTotal = 0;
  userConversationTotal = 0;
  prospectConversationTotal = 0;
  activeMessageTotal = 0;
  dailyEngagedUserAITotal = 0;

  constructor(
    data: Partial<
      AdvancedDailyEngagedUserMonthlyUsage& {
        metricConsumption?: { metricId: string; total: number }[];
      }
    >,
  ) {
    Object.assign(this, data);

    if (data.metricConsumption?.length) {
      const deu = data.metricConsumption.find((m) => m.metricId === 'DailyEngagedUser');
      const uc = data.metricConsumption.find((m) => m.metricId === 'UserConversation');
      const pc = data.metricConsumption.find((m) => m.metricId === 'ProspectConversation');
      const am = data.metricConsumption.find((m) => m.metricId === 'ActiveMessage');
      const deuAi = data.metricConsumption.find((m) => m.metricId === 'DailyEngagedUserAI');

      this.dailyEngagedUserTotal = deu?.total ?? 0;
      this.userConversationTotal = uc?.total ?? 0;
      this.prospectConversationTotal = pc?.total ?? 0;
      this.activeMessageTotal = am?.total ?? 0;
      this.dailyEngagedUserAITotal = deuAi?.total ?? 0;
    }
  }
}
